import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { Placement } from '@popperjs/core';
import { ContentTypeLogo } from 'src/dashboard/ContentTypeLogo';

interface SessionCardSmallProps{
  uuid: string;
  hidePreview?: boolean;
  titleContainerClassName?: string;
}

const contentNameClasses = 'text-bedrock-p text-bedrock-black line-clamp-2 lg:line-clamp-none my-auto';

export const SessionHoverableCardSmall = ({
  uuid,
  titleContainerClassName,
}: SessionCardSmallProps) => {
  const [placement, setPlacement] = useState<Placement | undefined>();
  const isPlacementResetRef = useRef(false);

  useEffect(() => {
    const onPageScrolled = () => {
      if (placement && !isPlacementResetRef.current) {
        isPlacementResetRef.current = true;
        setPlacement(undefined);
      }
    };

    window.addEventListener('scroll', onPageScrolled);

    return () => {
      window.removeEventListener('scroll', onPageScrolled);
    };
  }, [placement]);


  return (
    <div className='flex space-x-2'>
    <ContentTypeLogo
    contentType={'video'}
  />
       <div className={classNames('flex flex-col min-w-0 flex-grow-0', titleContainerClassName)}>

<span className={contentNameClasses} style={{ wordBreak: 'break-word' }}>
  {uuid}
</span>
</div>
      </div>
  );
};
